import { env } from '../configs/Config'
import { apiCMSWithToken } from './axios'

export const url = {
  customer: '/customer-data'
}
export async function getListData(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${url.customer}?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function getDetailData(id) {
  const response = await apiCMSWithToken.get(`${url.customer}/${id}`)
  return response
}

export async function showCustomerDataPhone(id) {
  const response = await apiCMSWithToken.get(`${url.customer}/${id}/show-phone`)
  return response
}

export async function dataImportExcel(body) {
  const response = await apiCMSWithToken.post(
    // `${F18_SERVICES.post}/import/excel`,
    `${url.customer}/import/excel`,
    body,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return response
}

export async function dataUpdate(body, id) {
  const response = await apiCMSWithToken.put(`${url.customer}/${id}`, body)
  return response
}

export async function dataAdd(body) {
  const response = await apiCMSWithToken.post(`${url.customer}`, body)
  return response
}

export async function dataDelete(body) {
  const response = await apiCMSWithToken.delete(`${url.customer}/deletes`, {
    data: body
  })
  return response
}

export async function listNote(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(`${env.api_url}/note?${params}`)
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function noteAdd(body) {
  const response = await apiCMSWithToken.post(
    `${env.api_url}/note/addnote`,
    body
  )
  return response
}

export async function noteUpdate(body, id) {
  const response = await apiCMSWithToken.put(`${env.api_url}/note/${id}/update-note`, body)
  return response
}

export async function noteDelete(body, id) {
  const response = await apiCMSWithToken.delete(`${env.api_url}/note/${id}`, {
    data: body
  })
  return response
}
